if (!customElements.get("countdown-timer")) {
  customElements.define(
    "countdown-timer",
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.updateCountdown = this.updateCountdown.bind(this);
      }

      connectedCallback() {
        this._initProperties();
        if (!this.timerDisplay) {
          console.error("Timer display element not found.");
          return;
        }
        if (isNaN(this.endDate)) {
          if (this.timerError) {
            this.timerError.innerHTML = `${this.translations.invalidDate}`;
          }
          return;
        }
        this.updateCountdown();
        this.interval = setInterval(this.updateCountdown, 1000);
      }

      // tz があるときは日本時間として解釈する。なければ従来どおり閲覧者の端末時間
      _parse(str, tz) {
        if (!str) return NaN;
        if (!tz) return Date.parse(str.replace(/-/g, "/"));
        const m = str.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        if (!m) return NaN;
        const p = (n) => String(n).padStart(2, "0");
        return Date.parse(`${m[1]}-${p(m[2])}-${p(m[3])}T${p(m[4] || 0)}:${m[5] || "00"}:00${tz}`);
      }

      updateCountdown() {
        const now = new Date().getTime();
        let target = this.endDate;
        let label = this.labelDuring;

        if (!isNaN(this.startDate) && now < this.startDate) {
          target = this.startDate;
          label = this.labelBefore;
        }

        const distance = target - now;

        if (distance < 0) {
          if (this.labelEl) this.labelEl.textContent = "";
          this.timerDisplay.innerHTML = `<span class="expired-message">${this.expiredMessage}</span>`;
          clearInterval(this.interval);
          return;
        }

        if (this.labelEl) this.labelEl.textContent = label || "";

        const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
        const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
        const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
        const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");

        this.timerDisplay.innerHTML = `
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${days}</div>
            <div class="wt-counter__item__label">${this.translations.days}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${hours}</div>
            <div class="wt-counter__item__label">${this.translations.hours}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${minutes}</div>
            <div class="wt-counter__item__label">${this.translations.minutes}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${seconds}</div>
            <div class="wt-counter__item__label">${this.translations.seconds}</div>
          </div>`;
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      _initProperties() {
        const tz = this.getAttribute("data-tz");
        this.endDate = this._parse(this.getAttribute("end-date"), tz);
        this.startDate = this._parse(this.getAttribute("start-date"), tz);
        this.labelBefore = this.getAttribute("data-label-before");
        this.labelDuring = this.getAttribute("data-label-during");
        this.expiredMessage = this.getAttribute("expired-message");
        this.timerDisplay = this.querySelector(".wt-countdown-timer__display");
        this.timerError = this.querySelector(".wt-countdown-timer__error");
        this.labelEl = this.querySelector(".wt-countdown-timer__label");
        const useLongLabels = this.hasAttribute("data-long-labels");
        this.translations = {
          days: useLongLabels ? this.getAttribute("data-translation-days-long") : this.getAttribute("data-translation-days") || "d",
          hours: useLongLabels ? this.getAttribute("data-translation-hours-long") : this.getAttribute("data-translation-hours") || "h",
          minutes: useLongLabels ? this.getAttribute("data-translation-minutes-long") : this.getAttribute("data-translation-minutes") || "m",
          seconds: useLongLabels ? this.getAttribute("data-translation-seconds-long") : this.getAttribute("data-translation-seconds") || "s",
          invalidDate:
            this.getAttribute("data-translation-invalid-date") ||
            "Invalid date format. Please enter the date and time in the format YYYY-MM-DD HH:MM.",
        };
      }
    },
  );
}